var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNomed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 hfsbPz",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 13.6c.182 0 .304.06.426.182l2.921 2.922c.243.183.243.548 0 .792l-2.921 2.921a.588.588 0 01-.853 0l-.065-.073a.534.534 0 01-.117-.353v-1.958c-2.169.068-3.892-.882-5.473-2.873a.9.9 0 111.41-1.12c1.256 1.582 2.468 2.257 4.062 2.191V14.21c0-.365.244-.609.61-.609zm.426-10.017l2.921 2.921c.243.244.243.609 0 .792l-2.921 2.922a.554.554 0 01-.426.182c-.366 0-.61-.243-.61-.609v-1.98c-1.989-.081-3.42.99-5.09 3.67-2.91 4.663-5.997 6.899-9.285 6.512a.9.9 0 11.21-1.788c2.442.288 4.966-1.54 7.547-5.678 1.97-3.157 3.93-4.61 6.619-4.518v-2c0-.146.039-.254.117-.353l.066-.073a.588.588 0 01.852 0zM9.776 8.99a.9.9 0 01-1.31 1.235c-1.752-1.859-3.447-2.644-5.12-2.447a.9.9 0 11-.211-1.787c2.304-.272 4.529.759 6.64 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomed);
export default __webpack_public_path__ + "static/media/nomed.88779b258f143535a86266d0550cf823.svg";
export { ForwardRef as ReactComponent };